import { v1 } from './v1';

export const API = {
  v1,
};
